import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

function VerifyBody({ loading, cert }) {
  if (loading) return <p className="mt-8 text-muted-foreground">Verifying...</p>;

  if (!cert) {
    return (
      <>
        <XCircle className="h-16 w-16 mx-auto text-destructive mt-6" />
        <h1 className="font-display text-3xl font-bold mt-4">Not found</h1>
        <p className="text-sm text-muted-foreground mt-2">This certificate could not be verified.</p>
      </>
    );
  }

  return (
    <>
      <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-500 mt-6" />
      <h1 className="font-display text-3xl font-bold mt-4">Certificate verified</h1>
      <p className="mt-2 text-sm text-muted-foreground">Issued to</p>
      <p className="font-display text-2xl font-bold">{cert.user_name}</p>
      <p className="mt-2 text-sm text-muted-foreground">for completing</p>
      <p className="font-semibold">{cert.course_title}</p>
      <p className="mt-4 text-xs text-muted-foreground">
        Score: {cert.score}% · Issued {new Date(cert.issued_at).toLocaleDateString()}
      </p>
    </>
  );
}

export default function CertificateVerify() {
  const { certId } = useParams();
  const [state, setState] = useState({ loading: true, cert: null });
  useEffect(() => {
    api.get(`/certificates/verify/${certId}`)
      .then((r) => setState({ loading: false, cert: r.data }))
      .catch(() => setState({ loading: false, cert: null }));
  }, [certId]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 royal-radial">
      <div className="max-w-md w-full bg-card rounded-3xl border border-border p-8 shadow-xl text-center">
        <Logo size={44} />
        <VerifyBody loading={state.loading} cert={state.cert} />
      </div>
    </div>
  );
}
